"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TranslatedIntroText = void 0;

var _react = _interopRequireWildcard(require("react"));

var _HelpOutlineOutlined = _interopRequireDefault(require("@material-ui/icons/HelpOutlineOutlined"));

var _Onboarding = require("@jobmatchme/ui/es/components/styleguide/Onboarding");

var _useOurTranslation = require("../../utils/useOurTranslation");

var _selectHint = _interopRequireDefault(require("./selectHint"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Funnel introtext component
 **/
var IntroText = function IntroText(_ref) {
  var headline = _ref.headline,
      textColor = _ref.textColor,
      toolTipVisible = _ref.toolTipVisible,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text,
      _ref$small = _ref.small,
      small = _ref$small === void 0 ? false : _ref$small,
      hintComponent = _ref.hintComponent;

  var _useContext = (0, _react.useContext)(_Onboarding.OnboardingContext),
      runOnboarding = _useContext.runOnboarding,
      getFunnelTarget = _useContext.getFunnelTarget;

  var funnelTarget = getFunnelTarget();
  var isToolTip = (0, _react.useCallback)(function () {
    return funnelTarget && toolTipVisible && toolTipVisible.indexOf(funnelTarget) > -1 ? true : false;
  }, [funnelTarget, toolTipVisible]);

  var getHelpBtn = function getHelpBtn(isVisible) {
    return isVisible && /*#__PURE__*/(0, _jsxRuntime.jsx)(_HelpOutlineOutlined.default, {
      className: _styleModule.default.help,
      onClick: function onClick() {
        runOnboarding && runOnboarding();
      }
    });
  };

  var prepareText = function prepareText(text) {
    if (text.length > 0 && text.includes('\n')) {
      return text.split('\n').map(function (item) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), item]
        });
      });
    } else return text;
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "".concat(_styleModule.default.box, " \n      ").concat(textColor && _styleModule.default[textColor] ? _styleModule.default[textColor] : '', " ").concat(small ? _styleModule.default.small : ''),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _styleModule.default.headline,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _styleModule.default.headlinePos,
        children: [headline, "\xA0", getHelpBtn(isToolTip())]
      })
    }), typeof hintComponent !== 'undefined' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_selectHint.default, {
      hintComponent: hintComponent
    }) : typeof text !== 'undefined' ? prepareText(text) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {})]
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(IntroText);

exports.default = _default;

var TranslatedIntroText = function TranslatedIntroText(_ref2) {
  var config = _ref2.config,
      _ref2$textColor = _ref2.textColor,
      textColor = _ref2$textColor === void 0 ? '' : _ref2$textColor;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(IntroText, {
    headline: t(config.translations.text),
    text: t(config.translations.hint, ''),
    textColor: textColor
  });
};

exports.TranslatedIntroText = TranslatedIntroText;